import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Particle from "../Particle";
import Github from "./Github";
import Techstack from "./Techstack";
import Aboutcard from "./AboutCard";
import laptopImg from "../../Assets/about.png";
import Toolstack from "./Toolstack";
import Timeline from "./Timeline";

function About() {
  return (
    <Container fluid className="about-section">
      <Particle />
      <Container>
        <Row style={{ justifyContent: "center", padding: "10px" }}>
          <Col
            md={7}
            style={{
              justifyContent: "center",
              paddingTop: "30px",
              paddingBottom: "50px",
            }}
          >
            <h1 style={{ fontSize: "2.1em", paddingBottom: "20px" }}>
              Sobre <strong className="purple">Mí</strong>
            </h1>
            <Aboutcard />
          </Col>
         <Col
  md={5}
  style={{ paddingTop: "120px", paddingBottom: "50px" }}
  className="about-img"
>
  <div className="about-image-box">
    <img src={laptopImg} alt="about" className="img-fluid" />
  </div>
</Col>

        </Row>

   
        {/* Professional Skillset */}
        <h1 className="project-heading" style={{ marginBottom: "40px" }}>
          Lenguajes <strong className="purple">Programación </strong>
        </h1>
        <Techstack />

        <h1 className="project-heading" style={{ marginBottom: "40px" }}>
          <strong className="purple">Herramientas y Frammeworks</strong> Usados
        </h1>
        <Toolstack />
  {/* Experiencia y educación */}
        <Timeline />
        
        <Github />
      </Container>
    </Container>
  );
}

export default About;
